<script setup>
import { computed } from 'vue'

const props = defineProps({
  type: {
    type: String,
    default: 'main',
  },
  title: {
    type: String,
  },
  tag: {
    type: Boolean,
    default: false
  },
  inline: {
    type: Boolean,
    default: false
  },
  pill: {
    type: Boolean,
    default: false
  },
  size: {
    type: String,
    default: 'sm',
    validator: (value) => ['xs', 'sm', 'md', 'lg'].includes(value)
  }
})

const type = computed(() => {
  switch (props.type) {
    case 'main':
      return 'text-surface-9 bg-surface-4';
    case 'online': return 'text-white bg-success';
    case 'enabled': return '!text-success bg-success-transparent';
    case 'offline': return 'text-white bg-offline';
    case 'orange': return 'text-white bg-orange'
    case 'gold': return 'text-black bg-gold'
    case 'yellow': return 'text-white bg-yellow'
    case 'error': return 'text-white bg-error'
    case 'blue': return 'text-white bg-main'
    case 'purple': return 'text-white bg-purple'
    case 'purple-dark': return 'text-white bg-purple-dark'
    case 'video': return 'text-white bg-video'
    case 'audio': return 'text-white bg-audio'
    default: return props.tag ? '!rounded-full badge-' + props.type : 'text-surface-9 bg-surface-4'
  }
})

const size = computed(() => {
  switch (props.size) {
    case 'xs': return 'text-[10px] font-medium leading-none !px-1 !py-0.5'
    case 'sm': return 'text-xs font-medium leading-none px-2 py-1'
    case 'md': return 'text-sm font-medium leading-none px-2 py-1'
    case 'lg': return 'text-base font-medium leading-none px-3 py-1'
  }
})
</script>

<template>
  <span :class="[size, type, pill ? 'rounded-full' : 'rounded', props.inline ? 'inline-flex' : 'flex', 'items-center']">
    {{ title }}
    <slot />
  </span>
</template>

<style>

</style>
